import {
  IEmail,
  IGetUserProfileStatus,
  IOnboardingResponse,
  IResponse,
  IResponseStages,
  ISendFile,
  ISetOnboarding,
  ISetUserProfileStatus,
  IVacantDescription,
} from 'utils/interfaces';

import { talentoApi } from './index';

const trackingExtensionApi = talentoApi.injectEndpoints({
  endpoints: (builder) => ({
    getStages: builder.query<IResponseStages, IEmail>({
      query({ email }) {
        return {
          url: `/tracking/contacts/vacant?email=${email}`,
        };
      },
    }),

    updateJobApplication: builder.mutation<IResponse, { email: string; phase: string; state: string; vacantName: string }>({
      query: ({ email, phase, state, vacantName }) => ({
        url: `/tracking/contacts/updateJobApplication`,
        method: 'POST',
        body: { email, phase, state, vacantName },
      }),
    }),

    sendFile: builder.mutation<IResponse, ISendFile>({
      query: ({ data, email, idStage, idVacant, idActivity, activityName }) => ({
        url: `/tracking/upload/file?email=${email}&idStage=${idStage}&idVacant=${idVacant}&idActivity=${idActivity}&activityName=${activityName}`,
        method: 'POST',
        body: data,
      }),
    }),

    getPreStageUser: builder.query<any, any>({
      query: (email) => ({
        url: `/tracking/contacts/vacant?email=${email}`,
      }),
    }),

    getVacantDescription: builder.query<IVacantDescription, { email: string }>({
      query: ({ email }) => {
        return {
          url: `/tracking/contacts/vacant/description?email=${email}`,
        };
      },
    }),

    getOnboarding: builder.query<IOnboardingResponse, string>({
      query: (email) => `/tracking/onboarding/${email}`,
      keepUnusedDataFor: 0,
    }),

    setOnboarding: builder.mutation<any, ISetOnboarding>({
      query: ({ email, dashboard, status }) => ({
        url: `/tracking/onboarding/${email}/${dashboard}/${status}`,
        method: 'PATCH',
      }),
    }),
    completeUserProfileProgress: builder.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: `/tracking/user-profile-progress/complete?email=${email}&status=Completed`,
        method: 'PATCH',
      }),
    }),
    getUserProfileProgress: builder.query<IGetUserProfileStatus, string>({
      query: (email) => ({
        url: `/tracking/user-profile-progress`,
        method: 'GET',
        params: {
          email,
        },
      }),
    }),
    setUserProfileProgress: builder.mutation<void, ISetUserProfileStatus>({
      query: ({ email, status }) => ({
        url: `/tracking/user-profile-progress/complete`,
        method: 'PATCH',
        params: {
          email,
          status,
        },
      }),
    }),
  }),
});

export const {
  useGetStagesQuery,
  useSendFileMutation,
  useGetPreStageUserQuery,
  useGetVacantDescriptionQuery,
  useGetOnboardingQuery,
  useSetOnboardingMutation,
  useCompleteUserProfileProgressMutation,
  useGetUserProfileProgressQuery,
  useUpdateJobApplicationMutation,
  useSetUserProfileProgressMutation,
} = trackingExtensionApi;
